import { useUser } from "@dashboard/auth";
import { hasPermissions } from "@dashboard/components/RequirePermissions";
import { PermissionEnum } from "@dashboard/graphql";
import { vendorListUrl } from "@dashboard/vendors/urls";
import { Button, Tooltip } from "@saleor/macaw-ui-next";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import { PrimaryActionProps } from "./type";
import { WelcomePageFakeDisabledButton } from "./WelcomePageFakeDisabledButton";

export const WelcomePageVendorsButton = ({ onClick }: PrimaryActionProps) => {
  const { user } = useUser();
  const userPermissions = user?.userPermissions || [];
  const hasPermissionToManageVendors = hasPermissions(userPermissions, [
    PermissionEnum.MANAGE_USERS,
  ]);

  if (!hasPermissionToManageVendors) {
    return (
      <Tooltip>
        <Tooltip.Trigger>
          <WelcomePageFakeDisabledButton>
            <FormattedMessage
              defaultMessage="Go to vendors"
              id="vendors.button"
              description="btn label"
            />
          </WelcomePageFakeDisabledButton>
        </Tooltip.Trigger>
        <Tooltip.Content>
          <Tooltip.Arrow />
          <FormattedMessage
            defaultMessage="You don't have permission to manage vendors"
            id="vendors.permission"
          />
        </Tooltip.Content>
      </Tooltip>
    );
  }

  return (
    <Link to={vendorListUrl()} onClick={onClick}>
      <Button variant="primary">
        <FormattedMessage defaultMessage="Go to vendors" id="vendors.button" description="btn label" />
      </Button>
    </Link>
  );
};